import React
    from "react";
import ErrorListItem
    from "./ErrorListItem";

const ErrorList = ({
                       errors = [],
                       ...rest
                   }) => {
    return (
        <ul className='fz-form-field-error-messages-list mb-0' {...rest}>
            {errors.map((error, index) => (
                <ErrorListItem error={error} key={index} />
            ))}
        </ul>
    )
}

export default ErrorList;